<template>
  <div style="height: 100%">
    <list-form
      ref="list-form"
      class="activity-review-list-form"
      :config="config"
      :formModel="formModel"
    >
      <template v-slot="{ data, item, autoSave }">
        <activity-review :data="data" :item="item" :model="formModel" :autoSave="autoSave" @onDetails="handleDetails"/>
      </template>
    </list-form>
    <dialog-status-repair-order />
    <dialog-new-instruction-repair-order />
    <dialog-status-customer />
    <dialog-new-instruction-customer />
    <dialog-connect
      ref="dialog-connect"
    ></dialog-connect>
    <dialog-activity-item :config="{ id: reviewDialogId, api: 'RepairExchangeOrderFollowUp' }" @onClose="handleClose"/>
  </div>
</template>

<script>
import { listConfig } from './ListFormConfig.js'
import { waitValue } from '@/utils/promises.js'
import { ModelOpenPO } from '@/models/RepairExchangeOrder'
export default {
  name: 'ListFormSupplierQuotes',
  components: {
    'activity-review': () => import(/* webpackChunkName: 'OpenPOReview' */ './ActivityReview'),
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index'),
    'dialog-status-repair-order': () => import(/* webpackChunkName: 'DialogStatusRepairOrder' */ '@/components/Shared/ActivityDialogStatusEmailRepairOrder'),
    'dialog-new-instruction-repair-order': () => import(/* webpackChunkName: 'DialogNewInstructionRepairOrder' */ '@/components/Shared/ActivityDialogNewInstructionRepairOrder'),
    'dialog-new-instruction-customer': () => import(/* webpackChunkName: 'DialogNewInstructionCustomer' */ '@/components/Shared/ActivityDialogNewInstructionCustomer'),
    'dialog-status-customer': () => import(/* webpackChunkName: 'ActivityDialogStatusEmailCustomer' */ '@/components/Shared/ActivityDialogStatusEmailCustomer'),
    'dialog-connect': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityConnectToCustomerPoFollowUp/Index'),
    'dialog-activity-item': () => import(/* webpackChunkName: 'OpenPOReview' */ './DialogActivityItem')
  },
  created () {
    this.$bus.$on('open-po-on-filter', this.handlerFilter)
    this.$bus.$on('export-supplier', this.handlerExportSupplier)
  },
  beforeDestroy () {
    this.$bus.$off('open-po-on-filter', this.handlerFilter)
    this.$bus.$off('export-supplier', this.handlerExportSupplier)
  },
  props: {
    orderBy: { type: Number, required: true }
  },
  watch: {
    orderBy () {
      this.getListForm()
        .then(list => list.loadData())
    }
  },
  data () {
    return {
      reviewDialogId: 'review-open-po'
    }
  },
  computed: {
    config () {
      return listConfig(this.orderBy)
    }
  },
  methods: {
    formModel () {
      return new ModelOpenPO()
    },
    handleDetails ({ id }) {
      const query = { [this.reviewDialogId]: `edit[${id}]` }
      this.$router.replace({ ...this.$router.currentRoute, query })
    },
    getListForm () {
      return waitValue(() => this.$refs['list-form'])
    },
    handlerFilter (filterValue) {
      this.getListForm()
        .then((list) => {
          list.setFilters(filterValue)
          list.loadData()
        })
    },
    handlerExportSupplier ({ isAll }) {
      this.getListForm()
        .then((listForm) => {
          listForm.exportToExcel({ isAll })
        })
    },
    handleClose () {
      return this.getListForm()
        .then((listForm) => {
          listForm.refresh()
        })
    },
    handlerConnect ({ rfqid }) {
      this.$refs['dialog-connect'].show({ rfqid })
    }
  }
}
</script>
